<template>
  <div :class="groupClass">
    <label :class="lableClass" :for="name">
      <slot>{{ title }}</slot>
    </label>

    <div :class="fieldClass">
      <!--Special Part Starts-->
      <multiselect
        :clear-on-select="false"
        :close-on-select="!multiple"
        :disabled="disabled"
        :group-label="groupSelect ? 'name' : ''"
        :group-select="groupSelect"
        :group-values="groupSelect ? 'service_types' : ''"
        :hide-selected="true"
        :loading="!ready"
        :multiple="multiple"
        :options="validServiceTypes"
        :placeholder="placeholder.length > 0 ? placeholder : 'Type to search'"
        :preserve-search="true"
        :show-labels="showLabels"
        :value="value"
        label="name"
        track-by="id"
        @input="update"
      >
        <template #noResult>
          <slot name="no-result">Oops! No result found.</slot>
        </template>
      </multiselect>
      <!--Special Part Ends-->

      <div
        v-if="form && form.errors.has(errorId)"
        class="invalid-feedback"
        v-text="form.errors.get(errorId)"
      ></div>
      <slot name="note"></slot>
    </div>

    <div :class="extraSlotClass">
      <slot name="extra"></slot>
    </div>
  </div>
</template>

<script type="text/babel">
import orderBy from "lodash/orderBy";
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  props: {
    multiple: {
      type: Boolean,
      default: true,
    },
    groupSelect: {
      type: Boolean,
      default: false,
    },
    showLabels: {
      type: Boolean,
      default: true,
    },
    filterByBrandIds: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      validServiceTypes: [],
    };
  },

  watch: {
    filterByBrandIds(newValue, oldValue) {
      if (!this.$lodash.isEqual(newValue, oldValue)) {
        this.getValidServiceTypes();
      }

      if (this.groupSelect) {
        this.$emit(
          "input",
          this.value.filter((serviceType) => this.filterByBrandIds.includes(serviceType.brand_id))
        );
      }
    },
  },

  mounted() {
    if (this.validServiceTypes.length === 0) {
      this.getValidServiceTypes();
    }
  },

  methods: {
    update(object) {
      if (this.form) {
        if (object !== undefined && object !== null) {
          this.form[this.name] = object;
        }

        this.form.errors.clear(this.errorId);
      }

      this.$emit("change", object);
    },

    getValidServiceTypes() {
      let url = "/brands?with=serviceTypes";

      if (this.filterByBrandIds.length > 0) {
        const ids = this.filterByBrandIds.join(",");

        url = `${url}&ids=${ids}`;
      }

      return this.$http.get(url).then((response) => {
        if (this.groupSelect) {
          this.validServiceTypes = this.$lodash.get(response, "body.data", []);
        } else {
          this.validServiceTypes = this.$lodash.get(response, "body.data[0].service_types", []);
        }

        this.validServiceTypes = orderBy(this.validServiceTypes, ["name"], ["asc"]);
      });
    },
  },
};
</script>
